/**
 * Thor IDs — the CRM's opportunity reference, as a member types it.
 *
 * Mirror of backend/domain/thor.ts (the subprojects share no code; lib/diff.ts + the backend's
 * domain/diff.ts are the precedent). Keep the two in step: the server normalises again on every
 * write and is the authority, this copy is what lets the field show `OP# 12345678` and a format
 * hint as the member types, without a round trip.
 *
 * Canonical form: `OP# 12345678` (`OP`, `#`, one space, digits). Accepted: that, `OP#12345678`,
 * `op # 12345678` and the bare `12345678`. The digit count is not checked — whether an opportunity
 * exists is Thor's answer to give.
 */

/** `OP#` (any case, any spacing around the `#`) then the digits — or the bare digits alone. */
const THOR_ID = /^(?:op\s*#\s*)?(\d+)$/i

/** The canonical `OP# <digits>` form of `input`, or `null` when it is not a Thor ID at all. */
export function normalizeThorId(input: string): string | null {
  const match = THOR_ID.exec(input.trim())
  return match ? `OP# ${match[1]}` : null
}
